/*
<div x-data="classOnView('in-view', { once: true, mode: 'inset', insetPx: 40 })"></div>
<div x-data="classOnView('in-view', { once: true, mode: 'ratio', ratio: 0.25 })"></div>
<div x-data="classOnView('in-view', { once: true, mode: 'minVisiblePx', minVisiblePx: 20 })"></div>
*/
(function () {
    function register(Alpine) {
        if (!Alpine || Alpine.__classOnViewRegistered) return;
        Alpine.__classOnViewRegistered = true;

        Alpine.data('classOnView', (className = '', opts = {}) => ({
            // options
            once: opts.once ?? true,
            rootMargin: opts.rootMargin ?? '0px',
            threshold: opts.threshold ?? [0, 0.01, 0.1, 0.25, 0.5, 1],

            // trigger modes:
            mode: opts.mode ?? 'inset',            // 'inset' | 'ratio' | 'minVisiblePx'
            insetPx: Number(opts.insetPx ?? 0),    // px inside viewport (for mode 'inset')
            ratio: Number(opts.ratio ?? 0.01),     // visible ratio (for mode 'ratio')
            minVisiblePx: Number(opts.minVisiblePx ?? 20), // visible px (for mode 'minVisiblePx')

            _observer: null,
            _classes: [],

            init() {
                if (typeof IntersectionObserver === 'undefined') {
                    console.warn('[classOnView] IntersectionObserver not supported');
                    return;
                }

                this._classes = String(className).split(/\s+/).filter(Boolean);

                this._observer = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (!entry.isIntersecting) continue;

                        if (this._shouldTrigger(entry)) {
                            this.$root.classList.add(...this._classes);

                            if (this.once && this._observer) this._observer.disconnect();
                            break;
                        }
                    }
                }, {
                    rootMargin: this.rootMargin,
                    threshold: this.threshold,
                });

                this._observer.observe(this.$root);
            },

            _shouldTrigger(entry) {
                const elRect = entry.boundingClientRect;      // element rect
                const visibleRect = entry.intersectionRect;   // visible part rect

                // viewport size
                const vw = window.innerWidth || document.documentElement.clientWidth;
                const vh = window.innerHeight || document.documentElement.clientHeight;

                if (this.mode === 'ratio') {
                    return entry.intersectionRatio >= this.ratio;
                }

                if (this.mode === 'minVisiblePx') {
                    // clamp requirement so tiny elements can still pass
                    const needW = Math.min(this.minVisiblePx, elRect.width);
                    const needH = Math.min(this.minVisiblePx, elRect.height);
                    return visibleRect && visibleRect.width >= needW && visibleRect.height >= needH;
                }

                // default: 'inset'
                // check how far inside viewport the element is (top/left/right/bottom)
                const inset = this.insetPx;

                const insideTop = elRect.top >= inset;
                const insideLeft = elRect.left >= inset;
                const insideRight = elRect.right <= (vw - inset);
                const insideBottom = elRect.bottom <= (vh - inset);

                // If you only care about vertical scrolling, you can relax left/right:
                const onlyVertical = opts.onlyVertical ?? true;
                if (onlyVertical) {
                    return insideTop && insideBottom;
                }

                return insideTop && insideLeft && insideRight && insideBottom;
            },

            destroy() {
                if (this._observer) this._observer.disconnect();
            },
        }));
    }

    document.addEventListener('alpine:init', () => register(window.Alpine));
    if (window.Alpine) register(window.Alpine);
})();
